export const COMPANYONESTOPSTOPLIST_SEARCH = 'COMPANYONESTOPSTOPLIST_SEARCH';
export const COMPANYONESTOPSTOPLIST_PAGE = 'COMPANYONESTOPSTOPLIST_PAGE';
export const COMPANYONESTOPSTOPLIST_STARTDATE = 'COMPANYONESTOPSTOPLIST_STARTDATE';
export const COMPANYONESTOPSTOPLIST_ENDDATE = 'COMPANYONESTOPSTOPLIST_ENDDATE';
